export function promoExpiration(){
    // Sample exDate: new Date(Date.UTC(2018, 9, 1, 4))
    // UTC time is 4 hours ahead of EST
    return new Date(Date.UTC(2019, 9, 1, 4));
}

function daysUntil(endDate) {
    const current = new Date();
    return Math.ceil((endDate - current) / (1000 * 60 * 60 * 24));
}

export function promoDaysLeft(){
    // return 0;
    return daysUntil(promoExpiration());
}

export function promoDaysLeftForStripe(){
    return daysUntil(promoExpiration());
}